import React, { useState } from 'react';
import axios from 'axios';

const MissingClips = () => {
    const [discordId, setDiscordId] = useState('');
    const [clipLink, setClipLink] = useState('');
    const [factionPlayerName, setFactionPlayerName] = useState('');
    const [eventDate, setEventDate] = useState('');
    const [eventTime, setEventTime] = useState('');
    const [killCount, setKillCount] = useState('');
    const [description, setDescription] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [loading, setLoading] = useState(false);
    const [formVisible, setFormVisible] = useState(false);

    const API_BASE = process.env.REACT_APP_API_BASE;

    const handleDiscordIdChange = (e) => {
        const value = e.target.value;
        setDiscordId(value);
        if (value.length < 17) {
            setFormVisible(false);
            resetForm();
        } else {
            setFormVisible(true);
        }
    };

    const resetForm = () => {
        setClipLink('');
        setFactionPlayerName('');
        setEventDate('');
        setEventTime('');
        setKillCount('');
        setDescription('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!discordId || !clipLink || !factionPlayerName || !eventDate || !eventTime) {
            setMessage('Bitte alle erforderlichen Felder ausfüllen.');
            setMessageType('danger');
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem('discord_token');
            const userResponse = await axios.get('https://discord.com/api/users/@me', {
                headers: { Authorization: `Bearer ${token}` }
            });
            const reporterId = userResponse.data.id;
            const reporterName = userResponse.data.username;

            await axios.post(`${API_BASE}/api/missing-clips`, {
                discordId,
                clipLink,
                factionPlayerName,
                eventDate,
                eventTime,
                killCount: killCount || '0',
                description,
                reporterId,
                reporterName
            }, { headers: { Authorization: `Bearer ${token}` } });

            setMessage('Fehlender Clip wurde im Discord gemeldet!');
            setMessageType('success');
            resetForm();
        } catch (error) {
            setMessage('Fehler beim Senden der Meldung.');
            setMessageType('danger');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modern-analyse-container">
            <style>{`
                .modern-analyse-container {
                    background: #05050a;
                    background-image: radial-gradient(circle at 50% -20%, #1e1e4a 0%, #05050a 80%);
                    min-height: 100vh;
                    padding: 60px 40px;
                    color: #ffffff;
                    font-family: 'Segoe UI', sans-serif;
                }
                .glass-card {
                    background: rgba(255, 255, 255, 0.02);
                    backdrop-filter: blur(20px);
                    border: 1px solid rgba(153, 50, 204, 0.07);
                    border-radius: 30px;
                    padding: 60px;
                    box-shadow: 0 25px 50px rgba(0,0,0,0.5);
                    transition: transform 0.3s ease;
                    margin-bottom: 30px;
                }

                .neon-text {
                    color: #9932cc;
                    text-shadow: 0 0 20px rgba(153, 50, 204, 0.6);
                    font-weight: 900;
                    text-transform: uppercase;
                    letter-spacing: 4px;
                    font-size: 3rem;
                }
                .futuristic-input {
                    background: rgba(0, 0, 0, 0.4) !important;
                    border: 1px solid rgba(255, 255, 255, 0.1) !important;
                    color: #fff !important;
                    border-radius: 15px !important;
                    padding: 15px 20px !important;
                    font-size: 1.1rem;
                    width: 65%;
                }
                .futuristic-input:focus {
                    border-color: #9932cc !important;
                    box-shadow: 0 0 20px rgba(153, 50, 204, 0.3) !important;
                }
                .btn-neon {
                    background: linear-gradient(90deg, #9932cc, #800080);
                    border: none;
                    color: white;
                    width: 65%;
                    border-radius: 15px;
                    font-weight: bold;
                    letter-spacing: 1.5px;
                    padding: 18px;
                    text-transform: uppercase;
                    box-shadow: 0 10px 30px rgba(153, 50, 204, 0.3);
                }
                .form-label {
                    color: rgba(255, 255, 255, 0.7) !important;
                    font-weight: 600;
                    font-size: 0.9rem;
                    margin-bottom: 1rem;
                    display: block;
                }

                .section-heading {
                    color: #9932cc;
                    font-size: 1.2rem;
                    font-weight: bold;
                    margin-bottom: 15px;
                    margin-top: 20px;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                }
                .description-box {
                    width: 100%;
                    height: 120px;
                    min-height: 120px;
                    max-height: 120px;
                }
            `}</style>

            <div className="container-fluid" style={{ maxWidth: '1200px' }}>
                <div className="text-center mb-5">
                    <h1 className="neon-text">Fehlende Clips</h1>
                    <p className="fs-5 opacity-50 mt-2">Trage fehlende Clips ein !</p>
                </div>

                {/* Discord ID Input */}
                <div className="glass-card mb-5">
                    <div className="d-flex align-items-center gap-3">
                        <span className="small text-uppercase opacity-50 fw-bold" style={{ whiteSpace: 'nowrap' }}>
                            User-Discord ID :
                        </span>
                        <div style={{ flex: '1', minWidth: '300px' }}>
                            <input a
                                type="text"
                                className="form-control futuristic-input"
                                placeholder="Discord ID eingeben..."
                                value={discordId}
                                onChange={handleDiscordIdChange}
                                style={{ padding: '10px 15px' }}
                            />
                        </div>
                        <span style={{ 
                            fontWeight: '900', 
                            letterSpacing: '1px', 
                            color: discordId.length >= 17 ? '#00ff88' : '#ff3366',
                            fontSize: '0.85rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <span style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                background: discordId.length >= 17 ? '#00ff88' : '#ff3366',
                                boxsalerno: discordId.length >= 17 ? '0 0 10px #00ff88' : '0 0 10px #ff3366',
                                display: 'inline-block'
                            }}></span>
                            STATUS: {discordId.length >= 17 ? 'CONNECTED' : 'Warte auf gültige Discord ID...'}
                        </span>
                    </div>
                </div>

                {/* Form */}
                {formVisible && (
                    <div className="glass-card animate__animated animate__fadeIn">
                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                            {/* Faction Player Name */}
                            <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label className="form-label small text-uppercase opacity-50 fw-bold">Gegnerische Fraktion/Partei</label>
                                <input
                                    type="text"
                                    className="form-control futuristic-input"
                                    value={factionPlayerName}
                                    onChange={(e) => setFactionPlayerName(e.target.value)}
                                    placeholder="Name des Spielers"
                                    required
                                />
                            </div>

                            {/* Clip Link */}
                            <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label className="form-label small text-uppercase opacity-50 fw-bold">Clip-Link *</label>
                                <input
                                    type="url"
                                    className="form-control futuristic-input"
                                    value={clipLink}
                                    onChange={(e) => setClipLink(e.target.value)}
                                    placeholder="Clip-Link eingeben..."
                                    required
                                />
                            </div>

                            {/* Date */}
                            <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label className="form-label small text-uppercase opacity-50 fw-bold">Wann? (Datum) *</label>
                                <input
                                    type="date"
                                    className="form-control futuristic-input"
                                    value={eventDate}
                                    onChange={(e) => setEventDate(e.target.value)}
                                    required
                                />
                            </div>

                            {/* Time */}
                            <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label className="form-label small text-uppercase opacity-50 fw-bold">Wieviel Uhr? *</label>
                                <input
                                    type="time"
                                    className="form-control futuristic-input"
                                    value={eventTime}
                                    onChange={(e) => setEventTime(e.target.value)}
                                    required
                                />
                            </div>

                            {/* Kill Count */}
                            <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label className="form-label small text-uppercase opacity-50 fw-bold">Anzahl der Kills</label>
                                <input
                                    type="number"
                                    className="form-control futuristic-input"
                                    value={killCount}
                                    onChange={(e) => setKillCount(e.target.value)}
                                    placeholder="0"
                                    min="0"
                                />
                            </div>

                            {/* Description Section */}
                            <div className="form-group" style={{ display: 'flex', flexDirection: 'column' }}>
                                <h4 className="section-heading">Zusätzliche Beschreibung</h4>
                                <textarea
                                    className="form-control futuristic-input description-box"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Weitere Details zum Clip..."
                                ></textarea>
                            </div>

                            {/* Submit Button */}
                            <div style={{ marginTop: '0.5rem' }}>
                                <button type="submit" className="btn btn-neon w-100 fs-5" disabled={loading}>
                                    {loading ? '📡 Übermittle Daten...' : '✅ Clip Meldung absenden'}
                                </button>
                            </div>
                        </form>

                        {message && (
                            <div className={`alert mt-4 bg-transparent border-${messageType === 'success' ? 'info' : 'danger'} text-white text-center animate__animated animate__shakeX`}>
                                {message}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MissingClips;
